import {
    createReducer,
    createNamespacer,
} from "../../commons/js/utils/reducer";

const initialState = {
    category: "",
    description: "",
    notes: "",
    headerNotes: "",
    coverSheet: "",
    pdfDrawings: "",
    bomId: "",
    headerNotesId: "",
    loading: false,
    bomNumber: "",
};

const packagesView = createNamespacer("PACKAGES_VIEW");

const packagesViewReducer = createReducer(initialState, {
    [packagesView("SET_CATEGORY")]: (state, action) => {
        return {
            ...state,
            category: action.payload.value,
        };
    },
    [packagesView("SET_DESCRIPTION")]: (state, action) => {
        return {
            ...state,
            description: action.payload.value,
        };
    },
    [packagesView("SET_LOADING")]: (state, action) => {
        return {
            ...state,
            loading: action.payload.value,
        };
    },
    [packagesView("SET_COVER_SHEET")]: (state, action) => {
        return {
            ...state,
            coverSheet: action.payload.value,
        };
    },
    [packagesView("SET_PDF_DRAWING")]: (state, action) => {
        return {
            ...state,
            pdfDrawings: action.payload.value,
        };
    },
    [packagesView("SET_NOTES")]: (state, action) => {
        return {
            ...state,
            notes: action.payload.value,
        };
    },
    [packagesView("SET_HEADER_NOTES")]: (state, action) => {
        return {
            ...state,
            headerNotes: action.payload.value,
        };
    },
    [packagesView("SET_HEADER_NOTES_ID")]: (state, action) => {
        return {
            ...state,
            headerNotesId: action.payload.value,
        };
    },
    [packagesView("SET_BOM_ID")]: (state, action) => {
        return {
            ...state,
            bomId: action.payload.value,
        };
    },
    [packagesView("SET_BOM_NUMBER")]: (state, action) => {
        return {
            ...state,
            bomNumber: action.payload.value,
        };
    },
});

export default packagesViewReducer;
